import { UIComponentHandler, UIComponentState, UIDataModel } from '../../toolkit/uicomponent';
import { BaseContext } from '../../../utils/basecontext';
import { UIComponentView } from '../../toolkit/uicomponentview';
import { UIComponentCSSStyle } from '../../toolkit/uicomponentcss';
import { MyAccountViewImpl } from './myaccountview';
import { MyAccountCSSStyleImpl } from './myaccountcss';
import { APIModelHandler, APIModel } from '../../toolkit/uicomponentapimodel';
import { MyAccountAPIModelImpl, MyAccountAPIModel } from './myaccountapimodel';
import { APIFeatures } from '../../../core/util/apifeatures';
import { CategoryDto } from '../../../core/dto/categories/categorydto';
import {PackStatusDto} from '../../../core/dto/packstatus/packstatusdto';
import { GetProfileDetailsDto } from '../../../core/dto/getprofile/getprofiledetailsdto';
import { MyAccountDto } from '../../../core/dto/myaccount/myaccountdto';
import { CRBTUIComponent, CRBTUIComponentProps } from '../home/crbt/crbtuicomponent';
import { AlertType } from '../../toolkit/alert/alerttype';
import { Strings } from 'src/com/sixdee/crbtportal/utils/resources/strings';


export enum PackStatus{
    SUBSCRIBE = "SUBSCRIBE", UNSUBSCRIBE = "UNSUBSCRIBE" , INPROGRESS = "INPROGRESS" ,
}
export interface MyAccountComponentProps extends CRBTUIComponentProps
{
  
}

export interface MyAccountComponentHandler extends UIComponentHandler
{
    onEditButtonClick(): void;
    onSaveChangesButtonClick():void;
    onCancelButtonClick():void;
    unSubscriber(): void;
}

export interface MyAccountComponentState extends UIComponentState
{
    username: string;
    selectedCategories: string[];
    userStatus: PackStatus;
    isEditable: boolean;
    
}

export class MyAccountComponent extends CRBTUIComponent<MyAccountComponentProps, MyAccountComponentState> implements MyAccountComponentHandler
{
    private count:number;
    constructor(props: MyAccountComponentProps)
    {
        super(props);

        this.state = {userStatus: PackStatus.SUBSCRIBE,
            username: "", selectedCategories: [], isEditable: false};
    }

    componentDidMount()
    {
        this.count = 3;
        (this.getView() as MyAccountViewImpl).showLoader();
      
      
        
        (this.getAPIModel() as MyAccountAPIModel).getCategories();
        (this.getAPIModel() as MyAccountAPIModel).getProfileDetailsAPI();
    }
    
    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new MyAccountViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new MyAccountCSSStyleImpl(applicationContext);
    }

    protected createAPIModel(applicationContext: BaseContext, apiModelHandler: APIModelHandler): APIModel
    {
         return new MyAccountAPIModelImpl(applicationContext, apiModelHandler);
    }
 
    onCancelButtonClick():void
    {
        this.setState({isEditable: false});
    }

    onSaveChangesButtonClick():void
    {
        
        if(this.getView().validate())
        {   
            (this.getView() as MyAccountViewImpl).showLoader();
            this.props.context.setUserContext(this.props.context.getUserContext());

            (this.getAPIModel() as MyAccountAPIModel).editProfileAPI((this.getView() as MyAccountViewImpl).getData());
        }
    }

    onEditButtonClick(): void 
    {
        this.setState({isEditable: true});
    }

    unSubscriber(): void 
    {
        (this.getView() as MyAccountViewImpl).showLoader();
        (this.getAPIModel() as MyAccountAPIModel).unsubscribeUser();
    }
    
    onSuccess(feature: APIFeatures, description: string, data: any): void 
    {   
       
      
        if(feature === APIFeatures.GET_PROFILE_DETAILS)
        {
            console.log("yellow");
            this.count--;

            if(this.count === 0)
                {
                       (this.getView() as MyAccountViewImpl).dismissLoader();
                }
             
              this.setState({username: (data as GetProfileDetailsDto).getUserName(),
            selectedCategories: (data as GetProfileDetailsDto).getCategories(), userStatus: this.state.userStatus});
            (this.getAPIModel() as MyAccountAPIModel).getPackStatusAPI();
          
        }
        else if(feature === APIFeatures.SIGNUP_CATEGORIES)
        {
            this.count--;
        
            if(this.count === 0)
            {
                (this.getView() as MyAccountViewImpl).dismissLoader();
            }
            (this.getView() as MyAccountViewImpl).updateCategoriesData(data as CategoryDto[]);
        }
        else if(feature === APIFeatures.PACK_STATUS)
        
        {
          
            this.count--;
        
            if(this.count === 0)
            {
                (this.getView() as MyAccountViewImpl).dismissLoader();
            }
            
            let packName = (data as PackStatusDto);
       
            console.log("----tigerpackName: " + packName);
            console.log("----tigerpackName from Cahce: " + this.props.context.getUserContext().getPackName());
            if((this.props.context.getUserContext().getPackName() === undefined || this.getContext().getUserContext().getPackName() === "") && (packName === undefined || packName.getPackName() === ""))
            {
                this.setState({userStatus:PackStatus.SUBSCRIBE});
            }

            else if(this.getContext().getUserContext().getPackName() !== undefined  && packName !== undefined)
            {
                this.setState({userStatus:PackStatus.UNSUBSCRIBE});
            } 
            else if(this.getContext().getUserContext().getPackName() !== undefined && packName === undefined)
            {
                this.setState({userStatus:PackStatus.INPROGRESS});
            }

        } 
        
        else if(feature === APIFeatures.DELETE_TONE)
        {
            (this.getView() as MyAccountViewImpl).dismissLoader();

            this.props.context.getUserContext().setPackName("");
            this.props.context.getUserContext().setPackDisplayName("");

            this.props.context.setUserContext(this.props.context.getUserContext());
            this.setState({userStatus:PackStatus.SUBSCRIBE});

            this.forceUpdate(()=>
            {
                (this.getView() as MyAccountViewImpl).showPopup(this.getContext().getResources().getString(Strings.nametune),this.getContext().getResources().getString(Strings.unsubscribersuccess),AlertType.SUCCESS);
            });

           
        }
        else if(feature === APIFeatures.EDIT_PROFILE)
        {
            (this.getView() as MyAccountViewImpl).dismissLoader();
            
            let categories: string[] = [];

            (data as MyAccountDto).getCategories().forEach((id: string) =>
            {
                categories.push(id);
            });
           

            this.setState({isEditable: false, username: (data as MyAccountDto).getUserName(),
                
                 selectedCategories: categories});

                 (this.getView() as MyAccountViewImpl).showPopup(this.getContext().getResources().getString(Strings.nametune),this.getContext().getResources().getString(Strings.profileupdationsuccess),AlertType.SUCCESS);
     
        }
        // else if(feature === APIFeatures.PACK_STATUS)
        // {
        //     this.setState({username: this.state.username, selectedCategories:this.state.selectedCategories,
        //         userStatus: this.props.context.getResources().getString(data)});
        //         if(this.count === 0)
        //         {
        //            (this.getView() as MyAccountViewImpl).dismissLoader();
        //         }
        // }
        window.scrollTo(0,0);
    }
    onFailure(feature: APIFeatures, description: string, data: any)
    {
        console.log("yellowfailcompo");
        if(feature === APIFeatures.EDIT_PROFILE)
        {

            (this.getView() as MyAccountViewImpl).dismissLoader();
            (this.getView() as MyAccountViewImpl).showPopup(this.getContext().getResources().getString(Strings.myaccount),this.getContext().getResources().getString(Strings.profileupdationfailure),AlertType.ERROR);
            
        }
        else if(feature === APIFeatures.GET_PROFILE_DETAILS)
        {
            (this.getView() as MyAccountViewImpl).dismissLoader();
            
            (this.getAPIModel() as MyAccountAPIModel).getPackStatusAPI();
            
        }
        else if(feature === APIFeatures.DELETE_TONE)
        {
            (this.getView() as MyAccountViewImpl).dismissLoader();
            
            (this.getView() as MyAccountViewImpl).showPopup(this.getContext().getResources().getString(Strings.myaccount),description,AlertType.ERROR);
            
        }
        
        else
        {
   
            this.count--;
        
            console.log("count--"+" :"+this.count);
          if(this.count === 0)
            {
               console.log("count=0"+" :"+this.count);
                (this.getView() as MyAccountViewImpl).dismissLoader();
                    
            }
        }

        window.scrollTo(0,0);
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/myaccount/myaccountcomponent.tsx